import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Loading from 'components/Loading';
import Page from 'containers/Page';
import auth from 'lib/auth';

const SignOutPage = ({ viewer }) => {
  useEffect(
    () => {
      auth.logout();
    },
    [],
  );
  return (
    <Page
      title='Sign Out'
      viewer={viewer}
    >
      <Loading />
    </Page>
  );
};

SignOutPage.propTypes = {
  viewer: PropTypes.object.isRequired,
};

export default SignOutPage;
